import Company from './views/Company.vue'

const route = [
  {
    path: '/liste-societe',
    name: 'society',
    component: Company,
    meta: {
      layout: 'light',
      auth: true,
      role: ['A','R','C','I']
    }
  }
]

export default route